<template>
    <div class="main">
        <!-- <div class="map" id="map" style="width:800px;height:800px"></div> -->
        <el-button @click="addcc">123</el-button>
        <el-button @click="sortArry([5,10,545,-41,5.45,0,55,-102,-66.6])">排序</el-button>
        <div class="hezi">
            <video autoplay="autoplay" loop="loop" muted="muted" src="http://img.nsmc.org.cn/CLOUDIMAGE/FY4A/MTCC/VIDEO/FY4A.huanan.24h.mp4"></video>
        </div>
        <Editor/>

        <div class="xixic">
            <div class="center-point"></div>
            <div class="surround-box">
                <div class="circle circle1">1</div>
                <div class="circle circle2">2</div>
                <div class="circle circle3">3</div>
                <div class="circle circle4">4</div>
                <div class="circle circle5">5</div>
                <div class="circle circle6">6</div>
                <div class="circle circle7">7</div>
                <div class="circle circle8">8</div>
                <div class="circle circle9">9</div>
                <div class="circle circle10">10</div>
                <div class="circle circle11">11</div>
                <div class="circle circle12">12</div>
            </div>
        </div>
    </div>
</template>

<script>
import L from 'leaflet';
import {addLeafletLayer} from "@/utils/convert"
import {tiledMapLayer} from '@supermap/iclient-leaflet';
import Editor from "./Editor.vue"
export default {
    name:'base-map',
    components:{
        Editor
    },
    props: ['width','height','mapType'],
    data(){
        return{
            mapView:null,
            resultLayer: null,
            drawData: {
                latLngs:[]
            }
        }
    },
    mounted(){
        // this.initBaseMap()
        
    },
    created(){
    },
    computed:{

    },
    methods:{
        sortArry(val){
            let len = val.length
            let minIndex,temp
            for(var i=0;i<len-1;i++){
                minIndex = i
                for(var j=i+1;j<len;j++){
                    if(val[j]<val[minIndex]){
                        minIndex = j
                    }
                }
                temp = val[i]
                val[i] = val[minIndex]
                val[minIndex] = temp
            }
            console.log(val);
        },
        addcc(){
            let a = addLeafletLayer()
            a = JSON.parse(a)
            //获取请求返回的layrid
            var layersID = a.newResourceID;
            console.log(layersID);
        },
        initBaseMap(){
            this.mapView = L.map('map', {
                center: [0 , 0],
                maxZoom: 18,
                zoom: 1
            });
            tiledMapLayer('http://120.196.115.131:8091/iserver/services/map-world3413/rest/maps/world3413',{
                noWrap:true
            }).addTo(this.mapView);

            // tiledMapLayer('http://120.196.115.131:8091/iserver/services/imageservice-bnu1/restjsr/collections/bnu1_0710_3413.ol',{
            //     noWrap:true
            // }).addTo(this.mapView);
            
            // tiledMapLayer('http://120.196.115.131:8091/iserver/services/map-imageservice/rest/maps/par_par',{
            //     noWrap:true
            // }).addTo(this.mapView);
            const rootUrl = "http://120.196.115.131:8091/iserver/services/imageservice-par/restjsr"
            let b = L.supermap.imageTileLayer(rootUrl, {
                noWrap:true,
                subdomains:["8091"],
                collectionId: "par",
                names: ["PAR_Hourly_Arctic_20200529.tif"]
            })
            b.addTo(this.mapView)
        },

    }
}
</script>


<style scoped>
.xixic{
    width: 400px;
    height: 400px;
    background: red;
    position: relative;
}
.surround-box,.center-point{
    position:absolute;
    top:50%;
    left:50%;
    width:20px;
    height:20px;
    margin-left:-10px;
    margin-top:-10px;
    border-radius:50%;
    background-color:#000;
}
.circle{
/*这里一定要绝对定位，这样位置才能铺开来*/
    position:absolute;
    top:-10px;
    left:-10px;
    width:40px;
    height:40px;
    line-height:40px;
    border-radius:50%;
    text-align:center;
    color:#fff;
}
.circle1{
    background-color:red;
    /*rotateZ控制方向，每个元素旋转30度，12个元素刚好360度。translateY控制每个元素距中心点的距离*/
    transform:rotateZ(30deg)translateY(80px);
}
.circle2{
    background-color:orange;
    transform:rotateZ(60deg)translateY(80px);
}
.circle3{
    background-color:yellow;
    transform:rotateZ(90deg)translateY(80px);
}
.circle4{
    background-color:green;
    transform:rotateZ(120deg)translateY(80px);
}
.circle5{
    background-color:seagreen;
    transform:rotateZ(150deg)translateY(80px);
}
.circle6{
    background-color:blue;
    transform:rotateZ(180deg)translateY(80px);
}
.circle7{
    background-color:purple;
    transform:rotateZ(210deg)translateY(80px);
}
.circle8{
    background-color:lightsalmon;
    transform:rotateZ(240deg)translateY(80px);
}
.circle9{
    background-color:deeppink;
    transform:rotateZ(270deg)translateY(80px);
}
.circle10{
    background-color:lightyellow;
    transform:rotateZ(300deg)translateY(80px);
}
.circle11{
    background-color:lightgreen;
    transform:rotateZ(330deg)translateY(80px);
}
.circle12{
    background-color:lightslategrey;
    transform:rotateZ(360deg)translateY(80px);
}
</style>
<style lang="scss" scoped>
.main{
    width: 100%;
    height: 100%;
}
.hezi{
    margin-left: 500px;
    margin-top: 300px;
    width:400px;
    height:400px;
    border: 1px solid red;
    overflow: hidden;
    position: relative;
    video{
        width: 2000px;
        height: 2000px;
        position: absolute;
        left: -600px;
        top: -200px;
        z-index: 100;
    }
}
</style>